module.exports = __webpack_public_path__ + "img/Box_delivery.92cb458a.svg";